/* eslint-disable */
import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { When } from 'react-if';
import SwiperCore, { Navigation, A11y, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Modal from 'react-modal';
import {injectIntl, FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import dayjs from 'dayjs';
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookIcon,
  EmailIcon
} from "react-share";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import '../../../assets/css/slick.css'

import Container from "../../common/Container";
import {ImageLeftTextRightBlock, VideoBlock} from "../../blocks";
import PetsSignupBlock from '../../blocks/PetsSignupBlock';
import {Flex, Box} from "../../common/Grid";
import Footer from "../../theme/Footer";
import IsDesktop from "../../common/IsDesktop";
import IsMobile from "../../common/IsMobile";
import IsMobilePortrait from "../../common/IsMobilePortrait";
import IsMobileLandscape from "../../common/IsMobileLandscape";
import Button from "../../common/Button";
import PetsAmbassador from "./components/ambassador";


import cupcake from '../../../assets/pets-images/header/cupcake.png';
import playicon from '../../../assets/pets-images/play-icon.svg';
import balou from '../../../assets/pets-images/new/balou.jpg';
import barbie from '../../../assets/pets-images/new/barbie.jpg';
import beng from '../../../assets/pets-images/new/beng.jpg';
import caymus from '../../../assets/pets-images/new/caymus.jpg';
import chai from '../../../assets/pets-images/new/chai.jpg';
import cleo from '../../../assets/pets-images/new/cleo.jpg';
import doris from '../../../assets/pets-images/new/doris.jpg';
import percy from '../../../assets/pets-images/new/percy.jpg';
import soya from '../../../assets/pets-images/new/soya.jpg';
import william from '../../../assets/pets-images/new/william.jpg';
import oleksiak from '../../../assets/pets-images/new/oleksiak.jpg';
import wendt from '../../../assets/pets-images/new/wendt.jpg';
import mobileHero from '../../../assets/images/penny-mobile.jpg';


import PennyStatic from '../../../assets/pets2023/penny-static.jpg';

import 'swiper/swiper.scss';
import sendEvent from "../../../helpers/sendAnalytics";

import ie11map from '../../../assets/pets-images/ie11map.png';
import Offers from "../../common/Offers";


import striptags from "striptags";
import DidYouKnow from "../../common/DidYouKnow";


// Assign modal app element
Modal.setAppElement('#___gatsby');

SwiperCore.use([Navigation, Pagination, A11y, Autoplay]);


const PetSlide1 = styled.div`
  width: 1200px;
  height: 100%;
  margin:0 calc(50% - 600px);
  position: absolute;
  left: 0;
  top: 5%;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: #fff;
  display: flex;
  align-items: center;
  p {
    max-width: 470px;
    margin-left: 100px;
    z-index: 3;
    ${tw`font-monteserrat text-xl font-normal text-black leading-loose`}
  }
  img {
    max-width: 700px;
    width: 100%;
  }
  @media screen and (max-width: 1400px) {
    p {
      padding-left: 20px;
    }
  }
  @media screen and (max-width: 1080px) {
    width: 100%;
    height: 100%;
    margin:0;
    flex-direction: column;
    img {
      max-width: 250px;
    }
    p {
      margin-left: 0;
      margin-bottom: 100px;
      display: block;
    }
  }
  @media screen and (min-width: 768px) and (max-width:1366px) and (orientation : landscape) {
     img {
       right: 200px;
     }
  }
  @media screen and (max-width: 650px) {
    p {
      top: 400px;
      text-align: center;
      max-width: 100%;
      padding: 0 20px;
      right: 0;
    }
    img {
      max-width: 340px;
      top: 20px;
      left: 0;
    }
  }
  @media screen and (max-width: 650px) {
    p {
      top: 350px;
      font-size: 1.15rem;
    }

    a {
      right: 20px;
    }
  }
  @media screen and (max-width: 650px) {
    img {
      max-width: 200px;
    }
  }
`

const PetSlide2 = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: #fff;
  blockquote {
    position: absolute;
    top: 50%;
    left: 10%;
    max-width: 450px;
    font-style: italic;
    z-index: 3;
    ${tw`font-monteserrat text-xl font-normal m-0 text-black leading-loose`}
    &:before {
      display: block;
      padding-left: 10px;
      content: "\\201C";
      font-size: 150px;
      line-height: 1;
      position: absolute;
      left: -80px;
      top: -20px;
      color: #D6D7EA;
      ${tw`font-montserrat`}

      @media screen and (max-width: 1450px) {
        left: 0;
        top: 55px;
        position: relative;
        display: inline-block;
        font-size: 120px;
        width: 42px;
        margin-right: 10px;
        padding: 0;
        line-height: 0;
      }
    }
    cite {
      ${tw`font-monteserrat text-xl font-bold m-0 leading-normal block mt-4`}
      color: #292B8F;
      span {
        font-weight: normal;
        font-style: italic;
      }
    }
  }
  :lang(fr) {
    blockquote {
      &:before {
        top: -80px;
        content: "«";
      }

      @media screen and (max-width: 1450px) {

        &:before {
          left: 0;
          top: 20px;
          position: relative;
          display: inline-block;
          content: "«";
          font-size: 120px;
          width: 42px;
          margin-right: 10px;
          padding: 0;
          line-height: 0;
        }
      }
    }
  }
  img {
    position: absolute;
    bottom: -50px;
    right: 10%;
    max-width: 700px;
    width: 100%;
    transform: scaleX(-1);
  }
  @media screen and (max-width: 1400px) {
    blockquote {
      padding-left: 20px;
    }
    img {
      position: absolute;
      bottom: -50px;
      right: 10%;
      max-width: 500px;
      width: 100%;
      transform: scaleX(-1);
    }
  }
  @media screen and (max-width: 1080px) {
    width: 100%;
    height: 100%;
    margin:0;
    img {
      right: 0%;
    }
  }
  @media screen and (max-width: 950px) {
    blockquote {
      bottom: auto;
      left: 0;
      right: 0;
      top: 0;
      text-align: center;
      max-width: 100%;
      padding: 0 20px;
    }
    img {
      left: auto;
      right: auto;
      max-width: 300px;
      top: 300px;
    }
  }
  @media screen and (max-width: 480px) {
    blockquote {
      bottom: 70px;
    }
  }
`


const BoxedShadow = styled.div`
  padding: 20px 40px;
  box-shadow: 0px 0px 15px rgba(0,0,0,0.4);
  width: 1250px;
  margin: -150px calc(50% - 625px) 50px;
  background: #fff;
  position: relative;
  z-index: 999;
  @media screen and (max-width: 1200px) {
    width: 100%;
    margin: 0;
    padding: 0;
  }
`
const PetsAdoptionStories = styled.section`
  padding: 40px 0;

  h2 {
    ${tw`font-monteserrat text-5xl font-normal mb-4 w-3/4`}

    @media screen and (max-width: 40em) {
      text-align: center;
      margin-top: 0;
      width: 100%;
    }
  }

  p {
    ${tw`font-monteserrat font-normal m-0 leading-normal`}
    max-width: 570px;

    @media screen and (max-width: 40em) {
      text-align: center;
    }
  }

  #videos {
    min-height: 696px;

    @media screen and (max-width: 40em) {
      min-height: 630px;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    cursor: pointer;
    position: absolute;
    z-index: 2;
    width: 40px;
    text-align: center;
    background: #00ACEE;
    border-radius: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-button-prev {
    top: calc(50% - 25px);
    left: 10px;

    @media screen and (max-width: 40em) {
      top: auto;
      bottom: 305px;
    }
  }

  .swiper-button-next {
    top: calc(50% - 20px);
    right: 10px;
    transform: rotate(180deg);

    @media screen and (max-width: 40em) {
      top: auto;
      bottom: 305px;
    }
  }

  @media screen and (max-width: 1080px) {
    margin-top: 50px;
  }

  .swiper-button-prev:before,
  .swiper-button-next:before {
    content:"‹";
    font-size: 60px;
    line-height: 1;
    font-weight: bold;
    color: #fff;
    position: relative;
    top: -4px;
    left: -2px;
    ${tw`font-montserrat`}
  }

  .swiper-button-prev:before {
    top: -5px;
    left: -3px;
  }

  .swiper-button-disabled {
    display: none;
  }

  & > div {
    position: relative;
    margin-top: 60px;
    :lang(fr) {
        margin-top: 100px;
    }


    & > a {
      position: absolute;
      right: 0;
      top: 0;

      @media screen and (max-width: 40em) {
        display: none;
      }

      @media only screen and (min-height:600px) and (max-height:700px) and (min-width:1200px) and (max-width:1300px) {
        right: 20px;
      }
    }
  }

  #videos {
    margin-top: 0;
  }

  @media screen and (max-width: 40em) {
    padding-top: 0;
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    h2 {
      font-size: 2.7rem;
    }
    & > div > a {
      right: 20px;
    }
  }

  @media only screen and (min-height:600px) and (max-height:700px) and (min-width:1200px) and (max-width:1300px) {
    h2 {
      margin-top: 0;
    }
  }
`

const PetSlideContainer = styled.div`
  ${tw`relative w-full py-12`}

  & > div {
    box-shadow: 0px 0px 39px rgba(0, 0, 0, 0.31);
    height: 600px;
    padding-top:420px;
    position: relative;
    background:black;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
    outline: none;

    &:hover,
    &:focus {
      outline: 4px solid #000;
    }
  }

  @media screen and (min-width: 1900px) {
    & > div {
      background-size: cover;
    }
  }

  @media screen and (max-width: 40em) {
    padding: 0;
    margin-bottom: 30px;

    & > div {
      box-shadow: none;
    }
  }
`

const PetSlideNewBanner = styled.div`
  background: #00ACEE;
  top: 0;
  ${tw`absolute font-montserrat font-bold text-xl py-1 tracking-wide text-white w-full uppercase text-center`}
`

const PetSlideName = styled.h3`
  ${tw`font-montserrat text-white font-bold text-3xl px-4 h-16 m-0 flex items-end justify-center text-center`}
`

const PetSlideDescription = styled.p`
  ${tw`font-monteserrat text-white text-center px-4 pt-5`}
`

const PetSlidePlayIcon = styled.div`
  position: absolute;
  left: calc(50% - 58px);
  top: calc(50% - 58px);
  background: url(${playicon}) no-repeat;
  width: 116px;
  height: 116px;
  user-select: none;
  -ms-user-select: none;
  pointer-events: none;
`

const PetsShelterWrapper = styled.div`
  margin-bottom: 10px;

  .shelter-support-icon {
    width: 300px;
  }

  h2 {
    ${tw`font-monteserrat text-4xl font-normal m-0`}
  }

  p {
    ${tw`font-monteserrat text-lg font-normal m-0 mt-8 leading-normal`}
    max-width: 500px;

    a {
      font-weight: bold;
      color: #000;
    }
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    p {
      max-width: 100%;
    }
  }

  @media screen and (max-width: 54em) {
    background: #F7F9FC;
  }
`

const ShelterPictures = styled.div`
  margin: 50px 0 0;
  min-height: 345px;

  & > p {
    margin-left: auto;
    text-align: right;
    ${tw`font-monteserrat text-sm font-normal mt-0 leading-normal`}

    @media screen and (max-width: 40em) {
      text-align: left;
    }
  }

  @media screen and (max-width: 54em) {
    img {
      width: 100%;
    }
  }

  @media screen and (max-width: 40em) {
    min-height: 846px;
  }
`

const PetsFaqCallout = styled.section`
  ${tw`font-monteserrat text-sm mt-0 leading-normal font-bold text-center pt-12 mt-24`}

  @media screen and (max-width: 54em) {
    ${tw`pt-0 px-4 mt-0`}
  }
`


const PetModalContent = styled.div`
  position: absolute;
  top: 10px;
  left: 0;
  right: 50px;
  z-index: 3;
  opacity: ${props => props.isPlaying ? '0': '1'};
  ${tw`flex items-start justify-between px-8`}
  width: 100%;

  h2 {
    ${tw`font-monteserrat text-4xl font-normal m-0 text-white`}
  }

  p {
    ${tw`font-monteserrat text-lg font-normal m-0 mt-4 leading-normal text-white`}
  }

  .petmodalshareclose {
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
  }

  @media screen and (max-width: 420px) {
    height: 150px;
    padding: 20px 1rem !important;

    h2 {
      padding-right: 95px;
      ${tw`text-3xl`}
    }

    p {
      ${tw`text-base`}
    }
  }

  @media screen and (max-width: 1024px) {
    top: 0;
    right: ${props => props.hasMobileVideo ? '0': '50px'};
    padding: ${props => props.hasMobileVideo ? '20px 2rem': '0 2rem'};
    background: ${props => props.hasMobileVideo ? 'linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(255,255,255,0) 100%)': 'none'};
    width: 100%;
    height: auto !important;
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1113px) {
    padding: 20px 1rem !important;

    & > a {
      margin-right: 50px;
    }
  }
`

const PetModalClose = styled.button`
  font-size: 40px;
  ${tw`font-monteserrat text-white border-0 cursor-pointer`}
  background: none;
  line-height: 28px;
  padding: 0;

  @media screen and (max-width: 420px) {
    font-size: 36px;
    line-height: 24px;
  }
`

const PetShareContainer = styled.div`
  display: flex;
  margin: 0 -.3rem;
  position: absolute;
  right: 0;
  top: 0;

  button {
    margin: 0 .3rem;
    display: block;

    svg {
      display: block;
    }
  }

  .copytoclipboard {
    width: 32px;
    height: 32px;
    background: #00ACEE;
    border: 0;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 14px .3rem;
    position: relative;
    color: #fff;
    padding: 0;

    svg {
      width: 20px;
      height: 20px;
      color: #fff;
    }

    .success {
      display: none;
      background: black;
      ${tw`font-montserrat`}
      color: #fff;
      font-size: 0.8rem;
      position: absolute;
      bottom: -34px;
      padding: .5rem 1rem;
      width: 160px;

      &.active {
        display: block;
      }
    }
  }

  @media screen and (max-width: 1266px) {
    position: static;
    margin-top: 1rem;
  }

  @media screen and (max-width: 767px) {
    justify-content: center;
  }
`

const PetShareText = styled.h4`
  ${tw`font-monteserrat text-base mr-3`}
`

const PetShareContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-top: 1rem;

  button {
    margin-bottom: 0.75rem;
    display: block;

    svg {
      display: block;
    }
  }

  .copytoclipboard {
    width: 32px;
    height: 32px;
    background: #00ACEE;
    border: 0;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0 0 .75rem 0;
    color: #fff;
    padding: 0;

    svg {
      width: 20px;
      height: 20px;
      color: #fff;
    }

    .success {
      display: none;
      background: black;
      ${tw`font-montserrat`}
      color: #fff;
      font-size: 0.8rem;
      position: absolute;
      bottom: 8px;
      padding: .5rem 1rem;

      @media screen and (max-width: 40em) {
        font-size: 0.7rem;
        right: 0;
        bottom: 48px;
      }

      &.active {
        display: block;
      }
    }
  }
`

const PetShelterImage = styled.img`
  mix-blend-mode: multiply;
  height: 200px;
  object-fit: contain;
  font-family: 'object-fit: contain;';
`

const WhitePetButton = styled(Button)`
  background: #141677;
  border: 1px solid #141677;
`

const PetShelterWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${PetShelterImage} {
    width: 100%;
    margin-bottom: 20px;
  }
`
const PetStoriesMobileSelect = styled.select`
  display: none;
  width: 100%;
  background: #E8E7E7;
  color: #4F5354;
  border: 0;
  appearance:none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25.906 16.894'%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath data-name='Clip 2' d='M0 0h16.894v25.906H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg data-name='Group 3' transform='rotate(90 12.953 12.953)' clip-path='url(%23a)'%3E%3Cpath data-name='Fill 1' d='M4.327 25.751l12.42-12.425a.545.545 0 000-.746L4.327.155a.527.527 0 00-.746 0L.155 3.583a.527.527 0 000 .746l8.621 8.625-8.621 8.623a.545.545 0 000 .747l3.427 3.427a.527.527 0 00.746 0' fill='%237e7e7e'/%3E%3C/g%3E%3C/svg%3E");
  background-size: 18px;
  background-position: 93% 50%;
  background-repeat: no-repeat;
  outline: none;
  ${tw`font-monteserrat font-semibold text-base px-4 py-3 pr-10 text-center mt-8`}

  @media screen and (max-width: 40em) {
    display: block;
  }
`

const MobileVideoBlock = styled(VideoBlock)`
  background: black;
  height: 100%;

  & > div {
    padding: 0 !important;
    height: 100% !important;

    & > div {
      padding: 0 !important;
      height: 100%;
    }
  }

  @media screen and (max-width: 40em) {
    align-items: flex-end !important;
  }
`

const MobileVideoBlockLandscape = styled(VideoBlock)`
  background: black;
  height: 100%;

  & > div {
    padding: 0 !important;
    height: 100% !important;

    & > div {
      padding: 0 !important;
      height: 100%;
    }
  }

  @media screen and (max-width: 40em) {
    align-items: flex-end !important;
  }
`


const VideoHolder = styled.div`
  height: 100%;

  & > div {
    height: 100%;
  }
`

const PetsShelterMapHeader = styled(Flex)`
  ${tw`pt-4 pb-8`}

  h2 {
    ${tw`font-montserrat font-normal text-3xl m-0`}
    color: #4F5354;
  }

  p {
    ${tw`font-monteserrat text-lg m-0`}
    color: #4F5354;
  }
`

const LeftArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className="arrow-left" id="arrow-left" onClick={onClick}></div>
  );
}

const RightArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className="arrow-right" id="arrow-right" onClick={onClick}></div>
  );
}

const PetShelterButton = ({url, image, alt}) => (
  <PetShelterWrapper>
    <PetShelterImage src={image} alt={alt} />

    <WhitePetButton to={url} external modification="pets" onClick={() => sendEvent({ga:{ category: 'Pets_Engagement', action: 'ShelterClick', label: alt.replaceAll(' ','_').replaceAll("'",'').replaceAll('.','')}})}>
      <FormattedHTMLMessage id="petspage.text25" />
    </WhitePetButton>
  </PetShelterWrapper>
)

const PetsHeader = styled.div`
  ${tw`relative w-full`}
  .poster-image {
    width: 100%;
    height: 50%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: cover;
  }
  overflow: hidden;
  width: 100%;
  position: relative;
  &.slide-0 ${PetSlide1} {
    z-index: 2;
  }
  &.slide-1 ${PetSlide2} {
    z-index: 2;
  }
  ${Container} {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 1;
    width: 100%;
  }
  .hfepp {
    width: 220px;
    position: relative;
    z-index: 99;
    margin-top: 12%;
    left: 00px;
  }
  & > div {
    height: 100%;
  }
  nav {
    position: absolute;
    z-index: 3;
    left: 10px;
    bottom: 250px;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      li {
        margin: 0 5px;
        button {
          width: 15px;
          height: 15px;
          border-radius: 100%;
          background: #292B8F;
          cursor: pointer;
          border: 0;
          opacity: 0.4;
          padding: 0;
          &.active {
            opacity: 1;
            width: 25px;
            height: 25px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .hfepp {
        margin-left: 10%;
      }
  }
  @media screen and (max-width: 1024px) {
    .hfepp {
      margin-left: 0;
      width: 170px;
      left: 20px;
      top: 20px;
    }
  }
  @media screen and (max-width: 600px) {
    > div {
        height: 100%;
    }
    .hfepp {
      width: 130px;
    }
    .hfepp {
        position: absolute;
        top: -400px;
      }
  }
  @media screen and (min-width: 768px) and (max-width:1366px) and (orientation : landscape) {
    nav {
      bottom: 20px;
    }
  }
  @media screen and (max-width: 650px) {
    nav {
      bottom: 20px;
      left: 50%;
      margin-left: -30px;
    }
    height: auto;
    min-height: auto;
    padding-bottom: 0px;
  }
  @media screen and (max-width: 380px) {
    .hfepp {
      width: 100px;
    }
  }
  @media screen and (max-width: 380px) {
    a {
      bottom: auto !important;
    }
  }
  @media only screen and (min-height:600px) and (max-height:700px) and (min-width:1200px) and (max-width:1300px) {
    img {
      max-width: 200px;
    }
    h2 {
      ${tw`mt-6 mb-0`}
    }
    h3 {
      ${tw`mt-4 mb-0`}
    }
  }
  @media only screen and (min-device-width: 724px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
    .video-holder {
      & > div {
        height: 100%;
        & > div {
          height: 100%;
          & > div {
            height: 100%;
            padding: 0;
          }
        }
      }
    }
  }
`

const BannerImage = styled.img`
  ${tw`w-full h-1/2 object-cover`}
`

const CupcakeContainer = styled.div`
  background-color: #2A2C94;
  ${tw`w-full pb-32 flex flex-end`}

  @media screen and (max-width: 1200px) {
    padding-bottom: 0;
  }
`

const CupcakeContainerContent = styled.div`
  width: 1250px;
  padding-right: 40px;

  ${tw`flex justify-between mx-auto`}

  @media screen and (max-width:1250px) {
    flex-direction: column;
    width: 90%;
    padding-bottom: 0;
    padding-right: 0;
    height: auto;
  }
`

const CupcakeContainerText = styled.div`
  width: 60%;
  padding-bottom: 40px;
  @media screen and (max-width:1250px) {
    width: 100%;
  }
`

const PetHeaderTitle = styled.h2`
  ${tw`font-monteserrat font-extrabold text-white`}
  font-size: 2.6rem;
`

const PetHeaderCaption = styled.h3`
  ${tw`font-monteserrat font-light text-white`}
  .small-mc {font-size : 1.1rem}
  font-size: 1.6rem;
`

const CupcakeImageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  height: 100%;
  width: 30%;

  @media screen and (max-width:1250px) {
    display: none;
  }
`

const CupcakeImage = styled.img`
  ${tw`object-cover`}
`


const PromoHeader = styled.div`
  ${tw`flex items-end text-white font-montserrat`}
  margin-top: 7%;
  :lang(fr) {
    margin-top: 2%;
  }
  .col1 {
    width: 60%;
    display: flex;
    align-items: flex-end;
    line-height: 2rem;
    margin-bottom: 1.5%;
    .hfepp {
      position: relative;
      left: 0;
      max-width: 100%;
      margin: 0 20px 0 0;
    }
  }
  .col2 {
    h1 {
      ${tw`font-bold text-5xl`}
      line-height: 4rem;
    }
    width: 40%;
    line-height: 2.4rem;
  }
  @media screen and (max-width: 1023px) {
    flex-direction: column;
    padding: 20px 0;
    .col1 {
      width: 100%;
      display: flex;
      align-items: flex-start;
      line-height: 2rem;
      margin-bottom: 1.5%;
      order: 1;
      span {
        padding-top: 30px;
        display: block;
        margin-left: 5px;
        font-size: 9pt;
        line-height: 1.7rem;
        b {
          font-size: 12pt;
        }
      }
      .hfepp {
        max-width: 100%;
        top: 0;
        margin: 0 20px 0 0;
      }
    }
    .col2 {
      padding-top: 200px;
      order: 2;
      h1 {
        ${tw`font-bold text-xl`}
        line-height: 2rem;
      }
      width: 100%;
      line-height: 1.7rem;
    }
  }
`


const PetAboutSectionText = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  ${tw`font-monteserrat text-lg m-0`}
  color: #4F5354;
  line-height: 1.6;
`

const useWindowSize = () => {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // timeoutId for debounce mechanism
    let timeoutId = null;
    // Handler to call on window resize
    function handleResize() {
      // prevent execution of previous setTimeout
      clearTimeout(timeoutId);
      // change width from the state object after 150 milliseconds
      timeoutId = setTimeout(() => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }, 150);
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

const PetSlide = React.forwardRef(({
    name,
    description,
    vimeo,
    mobileVimeo,
    isNew,
    image,
    eventName,
    intl
  }, ref) => {
  const [open, setOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const addPopState = () => {
    setOpen(false);
  }

  const handleOpen = () => {
    setOpen(true);

    if (typeof window !== "undefined" && window.history && window.history.pushState) {
      const url = new URL(window.location);
      url.searchParams.set('animal', eventName);

      window.history.pushState({}, '', url);

      window.addEventListener('popstate', addPopState);
    }
  }

  const handleClose = () => {
    setOpen(false);

    if (typeof window !== "undefined" && window.history && window.history.pushState) {
      window.history.back();

      window.removeEventListener('popstate', addPopState);
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      handleOpen();
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      const watchPet = urlParams.get('watch');
      if (watchPet === eventName) {
        setOpen(true);
      }
    }
  }, []);

  const size = useWindowSize();
  let height = '45vw';
  let width = '80vw';
  if (
    typeof window !== "undefined" &&
    window.innerWidth < 1024
  ) {
    height = `${size.height}px`;
    width = '100vw';
  }


  return (
    <PetSlideContainer>
      <div
        role="button"
        onClick={() => handleOpen()}
        onKeyDown={(e) => handleKeyDown(e)}
        aria-pressed={open}
        aria-label={`Open video for ${name}`}
        tabIndex={0}
        style={{backgroundImage:`url(${image})`}}
        ref={ref}
      >
        <When condition={isNew}>
          <PetSlideNewBanner><FormattedHTMLMessage id="petspage.text22" /></PetSlideNewBanner>
        </When>

        <PetSlidePlayIcon />

        <PetSlideName>
          {name}
        </PetSlideName>

        <PetSlideDescription dangerouslySetInnerHTML={{ __html: description }} />
      </div>

      <Modal
        isOpen={open}
        aria={{
          labelledby: "heading",
          describedby: "description"
        }}
        style={{
          overlay: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: '10000'
          },
          content: {
            top: 'auto',
            right: 'auto',
            left: 'auto',
            bottom: 'auto',
            width,
            height,
            maxHeight: '100vh',
            maxWidth: '177.78vh',
            padding: '0px',
            borderRadius: '0px',
            border: '0px',
            background: '#000',
            position: "relative"
          }
        }}
        className={mobileVimeo !== '' ? 'pets has-mobile-video' : 'pets'}
        shouldCloseOnOverlayClick
        preventScroll
        onRequestClose={() => handleClose()}
      >
        <PetModalContent hasMobileVideo={mobileVimeo} isPlaying={isPlaying}>
          <div>
            <h2 id="heading">
              {name}
            </h2>
            <p id="description" dangerouslySetInnerHTML={{ __html: striptags(description, [], '<br>') }} />
          </div>
          <div className="petmodalshareclose">
            <PetShareContainerModal>
              <FacebookShareButton url={`https://vimeo.com/${vimeo}`} beforeOnClick={() => sendEvent({ga:{category: 'Pets_Videos', action: 'Share', label: `Video_${eventName}`}})}>
                <FacebookIcon size={36} round />
              </FacebookShareButton>
              <CopyToClipboard text={`https://vimeo.com/${vimeo}`} onCopy={() => {sendEvent({ga:{category: 'Pets_Videos', action: 'Share', label: `Video_${eventName}`}});document.getElementById('success-modal').classList.add('active');setTimeout(() => {document.getElementById('success-modal').classList.remove('active')},1000)}}>
                <button type="button" className="copytoclipboard" title={intl.formatMessage({id:"petspage.text42"})}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                    />
                  </svg>
                  <div className="success" id="success-modal">
                    <FormattedMessage id="petspage.text43" />
                  </div>
                </button>
              </CopyToClipboard>
              <EmailShareButton url={`https://vimeo.com/${vimeo}`} beforeOnClick={() => sendEvent({ga:{category: 'Pets_Videos', action: 'Share', label: `Video_${eventName}`}})}>
                <EmailIcon size={36} round />
              </EmailShareButton>
            </PetShareContainerModal>

            <PetModalClose
              type="button"
              onClick={() => setOpen(false)}
              className="closebutton"
            >
              X
            </PetModalClose>
          </div>
        </PetModalContent>
        <VideoHolder>
          <When condition={mobileVimeo !== ''}>
            <IsDesktop>
              <VideoBlock
                url={`https://vimeo.com/${vimeo}`}
                responsive
                eventDetails={{play:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Play'},progress_25:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_25'},progress_50:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_50'},progress_75:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_75'},progress_100:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_100'}}}
                onPlay={() => setIsPlaying(true)}
              />
            </IsDesktop>
            <IsMobilePortrait>
              <MobileVideoBlock
                url={`https://vimeo.com/${mobileVimeo}`}
                eventDetails={{play:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Play'},progress_25:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_25'},progress_50:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_50'},progress_75:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_75'},progress_100:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_100'}}}
                responsive
              />
            </IsMobilePortrait>
            <IsMobileLandscape>
              <MobileVideoBlockLandscape
                url={`https://vimeo.com/${vimeo}`}
                eventDetails={{play:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Play'},progress_25:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_25'},progress_50:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_50'},progress_75:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_75'},progress_100:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_100'}}}
                responsive
              />
            </IsMobileLandscape>
          </When>
          <When condition={mobileVimeo === ''}>
            <VideoBlock
              url={`https://vimeo.com/${vimeo}`}
              responsive
              eventDetails={{play:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Play'},progress_25:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_25'},progress_50:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_50'},progress_75:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_75'},progress_100:{category:'Pets_Videos',label:`Video_${eventName}`,action:'Progress_100'}}}
              onPlay={() => setIsPlaying(true)}
            />
          </When>
        </VideoHolder>
      </Modal>
    </PetSlideContainer>
  )
})

const PetsPage = ({locale, intl, blogPosts}) => {



  const [province, setProvince] = useState(null);
  const [postalCode, setPostalCode] = useState('');
  const [slide, setSlide] = useState(0);
  const [isClient, setClient] = useState(false);
  const [windowWidth, setWindowWidth] = useState(1200);
  const [promoActive, setPromoActive] = useState(false);
  const [duringEvent, setDuringEvent] = useState(false);

  const today = dayjs();
  const cutoff = dayjs('2024-08-27');

  useEffect(() => {
    setClient(true);
    let today = dayjs()

    // show the promo from April 28th to April 30th
    if(today.isAfter(dayjs('2023-04-27')) && today.isBefore(dayjs('2023-05-01'))){
      setPromoActive(true)
    }

    setDuringEvent(today.isBefore(cutoff))

    // show the promo when passcode is provided
    let urlParams = new URLSearchParams(window.location.search);
    let passcode = urlParams.get('passcode');

    if(passcode === 'ShowPromo777'){
      setPromoActive(true);
    }

  }, []);

  const postalCodeForm = React.createRef();
  const shelterResults = React.createRef();

  const pet1 = React.createRef();
  const pet2 = React.createRef();
  const pet3 = React.createRef();
  const pet4 = React.createRef();
  const pet5 = React.createRef();
  const pet6 = React.createRef();
  const pet7 = React.createRef();
  const pet8 = React.createRef();
  const pet9 = React.createRef();
  const pet10 = React.createRef();
  const pet11 = React.createRef();
  const pet12 = React.createRef();
  const mobilePets = {
    pet1,
    pet2,
    pet3,
    pet4,
    pet5,
    pet6,
    pet7,
    pet8,
    pet9,
    pet10,
    pet11,
    pet12
  };

  const pets = [
    {
      id: 'pet11',
      name: intl.formatMessage({id:"petspage.pet11.name"}),
      description: intl.formatMessage({id:"petspage.pet11.description"}),
      vimeo: locale === 'en' ? "683462008":"683462093",
      mobileVimeo: locale === 'en' ? "683462049" : "683462131",
      isNew: true,
      image: oleksiak,
      ref: pet11,
      eventName: 'oleksiak'
    },
    {
      id: 'pet12',
      name: intl.formatMessage({id:"petspage.pet12.name"}),
      description: intl.formatMessage({id:"petspage.pet12.description"}),
      vimeo: locale === 'en' ? "683461848":"683461914",
      mobileVimeo: locale === 'en' ? "683461877" : "683461962",
      isNew: false,
      image: wendt,
      ref: pet12,
      eventName: 'wendt'
    },
    {
      id: 'pet1',
      name: intl.formatMessage({id:"petspage.pet1.name"}),
      description: intl.formatMessage({id:"petspage.pet1.description"}),
      vimeo: locale === 'en' ? "523740718":"523740766",
      mobileVimeo: locale === 'en' ? "531525811" : "531549359",
      isNew: false,
      image: caymus,
      ref: pet1,
      eventName: 'caymus'
    },
    {
      id: 'pet2',
      name: intl.formatMessage({id:"petspage.pet2.name"}),
      description: intl.formatMessage({id:"petspage.pet2.description"}),
      vimeo: locale === 'en' ? "523740895":"523740946",
      mobileVimeo: locale === 'en' ? "531536727" : "531723295",
      isNew: false,
      image: soya,
      ref: pet2,
      eventName: 'soya'
    },
    {
      id: 'pet3',
      name: intl.formatMessage({id:"petspage.pet3.name"}),
      description: intl.formatMessage({id:"petspage.pet3.description"}),
      vimeo: locale === 'en' ? "523740614":"523740673",
      mobileVimeo: locale === 'en' ? "531521901" : "531545952",
      isNew: false,
      image: balou,
      ref: pet3,
      eventName: 'balou'
    },
    {
      id: 'pet4',
      name: intl.formatMessage({id:"petspage.pet4.name"}),
      description: intl.formatMessage({id:"petspage.pet4.description"}),
      vimeo: locale === 'en' ? "523740791":"523740832",
      mobileVimeo: locale === 'en' ? "531530813" : "531713422",
      isNew: false,
      image: barbie,
      ref: pet4,
      eventName: 'barbie'
    },
    {
      id: 'pet5',
      name: intl.formatMessage({id:"petspage.pet5.name"}),
      description: intl.formatMessage({id:"petspage.pet5.description"}),
      vimeo: locale === 'en' ? "409827953":"409840528",
      mobileVimeo: locale === 'en' ? "561392821" : "561419286",
      isNew: false,
      image: william,
      ref: pet5,
      eventName: 'william'
    },
    {
      id: 'pet6',
      name: intl.formatMessage({id:"petspage.pet6.name"}),
      description: intl.formatMessage({id:"petspage.pet6.description"}),
      vimeo: locale === 'en' ? "409827606":"409840219",
      mobileVimeo: locale === 'en' ? "561390497" : "561416689",
      isNew: false,
      image: percy,
      ref: pet6,
      eventName: 'percy'
    },
    {
      id: 'pet7',
      name: intl.formatMessage({id:"petspage.pet7.name"}),
      description: intl.formatMessage({id:"petspage.pet7.description"}),
      vimeo: locale === 'en' ? "409825286" : "409834012",
      mobileVimeo: locale === 'en' ? "561382479" : "561408820",
      isNew: false,
      image: beng,
      ref: pet7,
      eventName: 'beng'
    },
    {
      id: 'pet8',
      name: intl.formatMessage({id:"petspage.pet8.name"}),
      description: intl.formatMessage({id:"petspage.pet8.description"}),
      vimeo: locale === 'en' ? "409826929":"409835968",
      mobileVimeo: locale === 'en' ? "561388931" : "561414768",
      isNew: false,
      image: doris,
      ref: pet8,
      eventName: 'doris'
    },
    {
      id: 'pet9',
      name: intl.formatMessage({id:"petspage.pet9.name"}),
      description: intl.formatMessage({id:"petspage.pet9.description"}),
      vimeo: locale === 'en' ? "409826378":"409835001",
      mobileVimeo: locale === 'en' ? "561386796" : "561412798",
      isNew: false,
      image: cleo,
      ref: pet9,
      eventName: 'cleo'
    },
    {
      id: 'pet10',
      name: intl.formatMessage({id:"petspage.pet10.name"}),
      description: intl.formatMessage({id:"petspage.pet10.description"}),
      vimeo: locale === 'en' ? "409825744":"409834392",
      mobileVimeo: locale === 'en' ? "561384898" : "561411014",
      isNew: false,
      image: chai,
      ref: pet10,
      eventName: 'chai'
    }
  ];
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const setPet = urlParams.get('pet');
    if (setPet === 'soya') {
      pets.unshift(pets.splice(1,1)[0]);
    } else if (setPet === 'balou') {
      pets.unshift(pets.splice(2,1)[0]);
    } else if (setPet === 'barbie') {
      pets.unshift(pets.splice(3,1)[0]);
    } else if (setPet === 'william') {
      pets.unshift(pets.splice(4,1)[0]);
    } else if (setPet === 'percy') {
      pets.unshift(pets.splice(5,1)[0]);
    } else if (setPet === 'beng') {
      pets.unshift(pets.splice(6,1)[0]);
    } else if (setPet === 'doris') {
      pets.unshift(pets.splice(7,1)[0]);
    } else if (setPet === 'cleo') {
      pets.unshift(pets.splice(8,1)[0]);
    } else if (setPet === 'chai') {
      pets.unshift(pets.splice(9,1)[0]);
    }
  }

  let interval = null;
  useEffect(() => {
    interval = setInterval(() => {
      // eslint-disable-next-line no-shadow
      setSlide(slide => (slide === 0) ? 1 : 0);
    }, 8000);
    if (typeof window !== 'undefined') {
      setWindowWidth(window.outerWidth);
    }
    return () => clearInterval(interval);
  }, []);

  const openPetModal = (event) => {
    if (
      typeof window !== 'undefined' &&
      mobilePets[event.target.value] &&
      mobilePets[event.target.value].current
    ) {
      mobilePets[event.target.value].current.click();
    }
  }

  let isIE = false;
  if (typeof window !== 'undefined') {
    isIE = /*@cc_on!@*/false || !!document.documentMode;
  }
  return (
    <React.Fragment>
      <main>
        { promoActive ?
          <PetsHeader className={`slide-${slide}`}>
            <picture>
                <source media="(max-width:1023px)" srcSet={mobileHero} />
                <img className="poster-image" src={PennyStatic} alt="Penny Oleksiak" />
            </picture>
            <Container width={1240}>
              <PromoHeader>
                <div className="col1">
                  <div>
                    { locale === 'en' ?
                      <img src={"https://img.imageboss.me/royale-images/width/800/format:webp/images/RHEPP_EN.png"} alt="Home for Every Pet Project - Royale" className="hfepp" />
                      :
                      <img src={"https://img.imageboss.me/royale-images/width/800/format:webp/images/RHEPP_FR.png"} alt="Home for Every Pet Project - Royale" className="hfepp" />
                    }
                  </div>
                  <div>
                    <FormattedHTMLMessage id="petspage.promoName" />
                  </div>
                </div>
                <div className="col2">
                  <h1><FormattedHTMLMessage id="petspage.promoHeader" /></h1>
                  <p><FormattedHTMLMessage id="petspage.promoText" /></p>
                </div>
              </PromoHeader>
            </Container>
          </PetsHeader>
          :
          <PetsHeader>
            <IsMobile>
              {
              duringEvent ?
              <BannerImage src={locale == 'fr' ? "https://img.imageboss.me/royale-images/width/468/format:webp/images/pets-banner-mobile-fr.jpg" : "https://img.imageboss.me/royale-images/width/468/format:webp/images/pets-banner-mobile.jpg"} alt='Top banner' /> :
              <BannerImage src={locale == 'fr' ? "https://img.imageboss.me/royale-images/width/468/format:webp/images/pets-banner-mobile-fr_v2.jpg" : "https://img.imageboss.me/royale-images/width/468/format:webp/images/pets-banner-mobile_v2.jpg"} alt='Top banner' />
              }
            </IsMobile>
            <IsDesktop>
              {
                duringEvent ?
                <BannerImage 
                src={locale === 'fr' 
                  ? "https://img.imageboss.me/royale-images/width/2300/format:webp/images/pets-banner-fr.jpg" 
                  : "https://img.imageboss.me/royale-images/width/2300/format:webp/images/pets-banner.jpg"} 
                alt='Top banner' 
              /> :
              <BannerImage 
              src={locale === 'fr' 
                ? "https://img.imageboss.me/royale-images/width/2300/format:webp/images/pets-banner-fr_v2.jpg" 
                : "https://img.imageboss.me/royale-images/width/2300/format:webp/images/pets-banner_v2.jpg"} 
              alt='Top banner' 
            />
              }
            </IsDesktop>
             <CupcakeContainer>
              <CupcakeContainerContent>
                <CupcakeContainerText>
                  {duringEvent && <PetHeaderTitle>
                    <FormattedHTMLMessage id="petspage.text47" />
                  </PetHeaderTitle>}
                  <PetHeaderCaption style={duringEvent ? {} : { paddingTop: '30px' }}>
                    <FormattedHTMLMessage id={duringEvent ? 'petspage.text48' : 'petspage.text48-v2'} />
                  </PetHeaderCaption>
                  {duringEvent &&
                    <PetHeaderCaption>
                      <FormattedHTMLMessage id="petspage.text49" />
                    </PetHeaderCaption>
                  }
                  </CupcakeContainerText>
                  <CupcakeImageContainer>
                    {duringEvent && <CupcakeImage src={cupcake} alt='Cupcake' />}
                  </CupcakeImageContainer>
                </CupcakeContainerContent>
              </CupcakeContainer>
            </PetsHeader>
        }

        <BoxedShadow id="shelters">
            <Box style={{padding:'10px 20px 0'}}>
              <FormattedMessage id={duringEvent ? 'petspage.text45' : 'petspage.text45-v2'}>
                {(txt) => (
                  <h2 dangerouslySetInnerHTML={{__html: txt}} />
                )}
              </FormattedMessage>
            </Box>
            <Box style={{margin:'0 20px', width: '70%'}}>
              <FormattedMessage id={duringEvent ? 'petspage.mapsmall' : 'petspage.mapsmall-v2'}>
                {(txt) => (
                  <p dangerouslySetInnerHTML={{__html: txt}} />
                )}
              </FormattedMessage>
            </Box>
          { isIE === false ? <iframe src="https://my.atlistmaps.com/map/52a82067-ec3f-48ea-8f07-9a32788ed306?share=true"
                                     allow="geolocation" width="100%" height={windowWidth < 700 ? "400px" : "700px"} frameBorder="0" scrolling="no"
                                     allowFullScreen /> : null }
          { isIE === true ? (
            <>
              <p style={{background:"red",color:"white",fontSize:"25px",fontWeight:"bold",fontFamily:'"Montserrat","DejaVu Sans","Verdana","sans-serif"',padding:"5px 10px"}}>{locale == 'fr' ? 'Veuillez utiliser un autre navigateur pour vous servir de la carte interactive.' : 'Please use another browser to use the interactive map.'}</p>
              <img src={ie11map} style={{width:"100%"}} alt="Royale" />
            </>
          ) : null}
        </BoxedShadow>

        <PetsAdoptionStories id="pet-stories">
          <Container>
            <h2><FormattedMessage id="petspage.text10" /></h2>
            <p><FormattedMessage id="petspage.text11" /></p>

            <PetShareContainer>
              <PetShareText>
                <FormattedMessage id="petspage.text44" />
              </PetShareText>
              <FacebookShareButton url={locale === 'fr' ? "https://royale.ca/fr/ami" : "https://royale.ca/pets"} beforeOnClick={() => sendEvent({ga:{ category: 'Pets_Engagement', action: 'Share', label: 'Watch_Share'}})}>
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <CopyToClipboard text={locale === 'fr' ? "https://royale.ca/fr/ami" : "https://royale.ca/pets"} onCopy={() => {sendEvent({ga:{category: 'Pets_Engagement', action: 'Share', label: 'Watch_Share'}});document.getElementById('success-watch').classList.add('active');setTimeout(() => {document.getElementById('success-watch').classList.remove('active')},1000)}}>
                <button type="button" className="copytoclipboard" title={intl.formatMessage({id:"petspage.text42"})}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                    />
                  </svg>
                  <div className="success" id="success-watch">
                    {intl.formatMessage({id:"petspage.text43"})}
                  </div>
                </button>
              </CopyToClipboard>
              <EmailShareButton url={locale === 'fr' ? "https://royale.ca/fr/ami" : "https://royale.ca/pets"} beforeOnClick={() => sendEvent({ga:{ category: 'Pets_Engagement', action: 'Share', label: 'Watch_Share'}})}>
                <EmailIcon size={32} round />
              </EmailShareButton>
            </PetShareContainer>
          </Container>
          <label className="hide" htmlFor="story-select">Select your story</label>
          <PetStoriesMobileSelect name="story-select" onChange={openPetModal}>
            <option value="">{intl.formatMessage({id:"petspage.text40"})}</option>
            <optgroup label={intl.formatMessage({id:"petspage.text37"})}>
              <option value="pet11">{intl.formatMessage({id:"petspage.text72"})}</option>
              <option value="pet12">{intl.formatMessage({id:"petspage.text73"})}</option>
              <option value="pet1">{intl.formatMessage({id:"petspage.text26"})}</option>
              <option value="pet4">{intl.formatMessage({id:"petspage.text27"})}</option>
              <option value="pet3">{intl.formatMessage({id:"petspage.text28"})}</option>
              <option value="pet5">{intl.formatMessage({id:"petspage.text29"})}</option>
              <option value="pet9">{intl.formatMessage({id:"petspage.text30"})}</option>
              <option value="pet7">{intl.formatMessage({id:"petspage.text31"})}</option>
            </optgroup>
            <optgroup label={intl.formatMessage({id:"petspage.text38"})}>
              <option value="pet2">{intl.formatMessage({id:"petspage.text32"})}</option>
              <option value="pet4">{intl.formatMessage({id:"petspage.text33"})}</option>
              <option value="pet6">{intl.formatMessage({id:"petspage.text34"})}</option>
              <option value="pet8">{intl.formatMessage({id:"petspage.text35"})}</option>
              <option value="pet10">{intl.formatMessage({id:"petspage.text36"})}</option>
            </optgroup>
          </PetStoriesMobileSelect>
          <div id="videos">
            <When condition={isClient}>
              <Swiper
                spaceBetween={20}
                slidesPerView={5}
                navigation
                allowTouchMove
                a11y
                breakpoints={{
                  320: {
                    slidesPerView: 1
                  },
                  767: {
                    slidesPerView: 3
                  },
                  1224: {
                    slidesPerView: 5
                  }
                }}
              >
                {pets.map(pet => (
                  <SwiperSlide>
                    <PetSlide name={pet.name} description={pet.description} vimeo={pet.vimeo} mobileVimeo={pet.mobileVimeo} isNew={pet.isNew} image={pet.image} ref={pet.ref} eventName={pet.eventName} intl={intl} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </When>
          </div>
        </PetsAdoptionStories>

        <PetsAmbassador />

        <PetsShelterWrapper id="sheltersupport">

          <Container>
          <img 
            src={locale === 'en' 
              ? "https://img.imageboss.me/royale-images/width/360/format:webp/images/shelter-support-icon.jpg" 
              : "https://img.imageboss.me/royale-images/width/360/format:webp/images/sheltersupportIconFR.jpg"} 
            className='shelter-support-icon' 
            alt="shelter support" 
          />
            <Flex flexWrap="wrap" flexDirection={['column', 'column', 'column', 'row']} mx={[0,0,0,-2]}>
              <Box width={[1,1,1,1/2]} px={[0,0,0,2]} pb={[0,0,0,5]}>
                <FormattedMessage id="petspage.text13">
                  {(txt) => (
                    <p dangerouslySetInnerHTML={{__html: txt}} />
                  )}
                </FormattedMessage>
                <FormattedMessage id={duringEvent ? 'petspage.text14' : 'petspage.text14-v2'}>
                  {(txt) => (
                    <p dangerouslySetInnerHTML={{__html: txt}} />
                  )}
                </FormattedMessage>
              </Box>
              <Box width={[1,1,1,1/2]} mb={[5,5,5,0]} px={[0,0,0,2]} pb={[0,0,0,5]}>
                <FormattedMessage id="petspage.text15">
                  {(txt) => (
                    <p dangerouslySetInnerHTML={{__html: txt}} />
                  )}
                </FormattedMessage>
                <p>
                  <a href="mailto:pets@royale.ca">pets@royale.ca</a>
                </p>
              </Box>
            </Flex>
            <ShelterPictures>
              <Flex flexWrap="wrap" mx={[0, 0, -3, -3]} style={{'margin-bottom': '30px'}}>
                <Box width={[1, 1/3, 1/3, 1 / 3]} px={[0, 0, 3, 3]} mb={[3,3,3,0]}>
                  <img
                    src={"https://img.imageboss.me/royale-images/width/470/format:webp/images/penny1.jpg"}
                    alt="Royale"
                  />
                </Box>
                <Box width={[1, 1/3, 1/3, 1 / 3]} px={[0, 0, 3, 3]} mb={[3,3,3,0]}>
                  <img
                    src={"https://img.imageboss.me/royale-images/width/470/format:webp/images/penny2.jpg"}
                    alt="Royale"
                  />
                </Box>
                <Box width={[1, 1/3, 1/3, 1 / 3]} px={[0, 0, 3, 3]}>
                  <img
                    src={"https://img.imageboss.me/royale-images/width/470/format:webp/images/penny3.jpg"}
                    alt="Royale"
                  />
                </Box>
              </Flex>
            </ShelterPictures>
          </Container>
        </PetsShelterWrapper>

        <DidYouKnow blogPosts={blogPosts} locale={intl.locale} />
        <br/><br/>

        <div id="footer">
          <PetsSignupBlock locale={locale} id="signup" />
        </div>

        <PetsFaqCallout>
          <FormattedMessage id="petspage.text17">
            {(txt) => (
              <p dangerouslySetInnerHTML={{__html: txt}} />
            )}
          </FormattedMessage>
        </PetsFaqCallout>
      </main>

      <Offers />
      {promoActive ?
        <Footer hideSignUp
                extraRules={
                  intl.locale == 'fr' ? '<sup>†</sup>Les dons seront égalés jusqu’à concurrence de 500 $ par refuge entre le 28 avril 2023 à 0 h (HE) et le 30 avril 2023 à 23 h 59 min 59 s (HE). La liste ci-dessus renferme tous les refuges admissibles pour lesquels Royale<sup>®</sup> versera des sommes équivalentes aux dons recueillis. Les refuges qui auront amassé le montant maximal de 500 $ continueront de figurer sur le site afin qu’ils puissent continuer à amasser des dons.<br/>*D’après le rapport statistique sur les refuges pour animaux canadiens de 2020, Humane Canada.<br>' : '<sup>†</sup>Donations will be matched up to a maximum of $500 per shelter between April 28, 2023 12:00:00AM (ET) and April 30, 2023 11:59:59PM (ET). The shelter list above contains all eligible shelters for which Royale<sup>®</sup> will be matching donations. Shelters who have accumulated the $500 will be kept on the site to allow continued donation. <br/>*Based on Canadian Animal Shelter Statistics Report published in 2020 by Humane Canada<br>'
                }

                />
        :
        <Footer
          hideSignUp
          extraRules={intl.locale == 'fr'
            ? "*D’après le rapport statistique sur les refuges pour animaux canadiens de 2020, Humane Canada.<br>"
            : "*Based on Canadian Animal Shelter Statistics Report published in 2020 by Humane Canada<br>"
          }
          petsPageFooterText={duringEvent && (intl.locale == 'fr'
            ? '<sup>†</sup>Nous égalerons les dons faits aux refuges participants entre le 8 et le 26 août, jusqu’à concurrence de 500 $ CAN par refuge.'
            : '<sup>†</sup>We will match donations made between August 8 and August 26 to participating shelters up to $500 CAD per shelter.'
          )}
        />
      }
    </React.Fragment>
  )
}

export default injectIntl(PetsPage)
